import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

/**
 * Toast properties.
 */
export interface IToastBodyProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  variant?: string;
}

const variantMapper: { [index: string]: string } = {
  primary: 'bg-primary text-light',
  secondary: 'bg-secondary',
  success: 'bg-success text-light',
  info: 'bg-info text-dark',
  warning: 'bg-warning',
  danger: 'bg-danger text-white',
  light: 'bg-light',
  dark: 'bg-dark text-white',
  white: 'bg-white',
};
/**
 *
 */
export const ToastBody: React.FC<IToastBodyProps> = (props) => {
  return (
    <div
      className={C(
        props.className,
        'toast-body',
        'rounded',
        props.onClick && '.cursor-pointer',
        props.variant && variantMapper[props.variant]
      )}
      onClick={props.onClick ? props.onClick : undefined}
    >
      {props.children}
    </div>
  );
};
